import React from "react";
import { CheckCircle2, XCircle, Clock, AlertCircle } from "lucide-react";

/**
 * Unified status badge used in Enterprise Contacts and Payment History.
 *
 * Supported statuses:
 *   contacted | not_contacted | pending
 *   paid      | failed        | refunded
 *   active    | inactive
 */
const STATUS_MAP = {
  // Enterprise contact statuses
  contacted:     { label: "Contacted",     cls: "bg-green-50 text-green-600 border-green-200",   Icon: CheckCircle2 },
  not_contacted: { label: "Not Contacted", cls: "bg-red-50   text-red-500   border-red-200",     Icon: XCircle },
  pending:       { label: "Pending",       cls: "bg-amber-50  text-amber-600 border-amber-200",  Icon: Clock },
  // Payment statuses
  paid:          { label: "Paid",          cls: "bg-emerald-50 text-emerald-600 border-emerald-200", Icon: CheckCircle2 },
  failed:        { label: "Failed",        cls: "bg-red-50    text-red-500    border-red-200",    Icon: XCircle },
  refunded:      { label: "Refunded",      cls: "bg-amber-50  text-amber-600  border-amber-200", Icon: AlertCircle },
  // Generic
  active:        { label: "Active",        cls: "bg-green-50  text-green-600  border-green-200", Icon: CheckCircle2 },
  inactive:      { label: "Inactive",      cls: "bg-gray-100  text-gray-500   border-gray-200",  Icon: XCircle },
};

const StatusBadge = ({ status = "" }) => {
  const cfg = STATUS_MAP[status.toLowerCase()] ?? {
    label: status,
    cls:   "bg-gray-100 text-gray-500 border-gray-200",
    Icon:  AlertCircle,
  };

  return (
    <span className={`inline-flex items-center gap-1.5 border text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap ${cfg.cls}`}>
      <cfg.Icon className="w-3.5 h-3.5 flex-shrink-0" />
      {cfg.label}
    </span>
  );
};

export default StatusBadge;
